var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.inMyTickList)?_c('v-btn',{attrs:{"text":"","color":"red","loading":_vm.loadingDelete},on:{"click":function($event){return _vm.removeFromTickList()}}},[_c('v-icon',{attrs:{"left":""}},[_vm._v("\n    "+_vm._s(_vm.mdiDelete)+"\n  ")]),_vm._v("\n  "+_vm._s(_vm.$t('actions.removeFromMyTickList'))+"\n")],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }